// Get runtime environment variables from window._env_ (injected at container startup)
// Fall back to localhost for local development
const getEnvVar = (key, defaultValue) => {
  // Check if window._env_ exists and has the key
  if (window._env_ && window._env_[key] && !window._env_[key].startsWith("__")) {
    return window._env_[key];
  }
  if (process.env[key]) {
    return process.env[key];
  }
  return defaultValue;
};

const config = {
  serverUrl: getEnvVar("REACT_APP_SERVER_URL", "http://localhost:3000"),
  clientUrl: getEnvVar("REACT_APP_CLIENT_URL", "http://localhost:3001")
};

export default config;
